import { ContainerHeightResize } from "@components/container-height-resize";
import { Route, Routes } from "react-router-dom";
import { TourSidebar } from "./screens/tour-sidebar";

export const TourDetails: React.FC = () => {
    return (
        <ContainerHeightResize>
            <Routes>
                <Route
                    path="ticket_sidebar"
                    element={<TourSidebar location="ticket_sidebar" />}
                />
                <Route
                    path="user_sidebar"
                    element={<TourSidebar location="user_sidebar" />}
                />
            </Routes>
        </ContainerHeightResize>
    );
};
